export const SET_KIOSK_DISPENSARY = 'SET_KIOSK_DISPENSARY';

interface SetKioskDispensary {
  type:       typeof SET_KIOSK_DISPENSARY,
  dispensary: string
}

export type KioskActionTypes = SetKioskDispensary;